import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <h1>
          Something went wrong. Please use different browsers. Our website is
          optimized on Chrome.
        </h1>
      )
    }
    // eslint-disable-next-line react/prop-types
    return this.props.children
  }
}

export default ErrorBoundary
